import { useStyles } from '@webapps/styles';

const BillingModel = ({contentRefs, billingData}) => {
  const { css } = useStyles();

  const htmlStaticStyle = {
    // General container styles
    contentCv: {
      display: 'flex',
      flexDirection: 'column',
    },
    container: {
      width: '794px', // Width for A4
      backgroundColor: '#ffffff',
      boxShadow: '0 0 5px rgba(0,0,0,0.2)',
      overflow: 'hidden',
      padding: '40px',
    },
    rowContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    highlightDropArea: {
      height: '50px',
      backgroundColor: 'rgba(0, 255, 0, 0.2)',
      border: '1px dashed #0f0',
    },
    textStyle: {
      fontSize: '14px',
      fontFamily: 'Arial, sans-serif',
      color: '#333',
      margin: '4px'
    },
    titleStyle: {
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#000',
      margin: '4px'
    },
  };  
  

  return (
    <div ref={(el) => (contentRefs.current = el)} id="pdf-content-container" style={htmlStaticStyle.container} className={css({ display: 'none' })}>
      <h1>Facture</h1>
      <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #000' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #000', padding: '8px' }}>Montant</th>
            <th style={{ border: '1px solid #000', padding: '8px' }}>Quantité</th>
            <th style={{ border: '1px solid #000', padding: '8px' }}>Nature Ligne</th>
          </tr>
        </thead>
        <tbody>
          {billingData?.lines?.map((line, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>
                {line?.amount}
              </td>
              <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>
                {line?.quantity}
              </td>
              <td style={{ border: '1px solid #000', padding: '8px', textAlign: 'center' }}>
                {line?.lineType}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div>
        Montant Total: {billingData?.montantTotal}
      </div>
    </div>
  );
};


export default BillingModel;